import "./App.css";
import "./styles/retro.css";
import "./styles/admin.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import AdminPage from "./pages/AdminPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-center"
        toastOptions={{
          style: {
            background: '#fff6d8',
            color: '#000000',
            border: '3px solid #5722a8',
            fontFamily: 'VT323, monospace',
            fontSize: '1.2rem',
          },
        }}
      />
    </div>
  );
}

export default App;
